import React from "react";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import logo from "../../assets/img/logo.png"; // Adjust path as needed

export default function App() {
  return (
    <MDBFooter
      bgColor="light"
      className="text-center text-lg-start text-muted"
      style={{ color: "#212529" }}
    >
      <br />
      <section className="">
        <MDBContainer className="text-center text-md-start mt-5">
          <MDBRow className="mt-6">
            <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
              <img
                src={logo}
                alt="Logo"
                width="110"
                height="110"
                className="d-inline-block align-top footer-logo"
                style={{
                  animation: "floatBounce 4s ease-in-out infinite",
                  display: "block",
                  margin: "0 auto",
                  boxShadow: "0 1px 0px rgba(239, 7, 7, 0.2)",
                  borderRadius: "50%",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
              />

              <h6
                className="fw-bold mb-4"
                style={{
                  textAlign: "center",
                  color: "#212529",
                  fontSize: "1.5rem",
                  marginTop: "20px",
                }}
              >
                Texas School of Mental Health
              </h6>
              <p style={{ textAlign: "center", fontSize: "15px" }}>
                Connecting cancer patients, caregivers, and healthcare
                professionals with specialized psycho-oncology support.
              </p>
            </MDBCol>

            <MDBCol
              md="2"
              lg="2"
              xl="2"
              className="mx-auto mb-4"
              style={{ textAlign: "center" }}
            >
              <h6
                className="text-uppercase fw-bold mb-4"
                style={{ color: "#212529" }}
              >
                Platform
              </h6>
              <p>
                <a
                  href="#!"
                  className="text-reset"
                  style={{ fontSize: "14px" }}
                >
                  How It Works
                </a>
              </p>
              <p>
                <a
                  href="#!"
                  className="text-reset"
                  style={{ fontSize: "14px" }}
                >
                  Find Counselors
                </a>
              </p>
              <p>
                <a
                  href="#!"
                  className="text-reset"
                  style={{ fontSize: "14px" }}
                >
                  Become a Counselor
                </a>
              </p>
            </MDBCol>

            <MDBCol
              md="3"
              lg="2"
              xl="2"
              className="mx-auto mb-4"
              style={{ textAlign: "center" }}
            >
              <h6
                className="text-uppercase fw-bold mb-4"
                style={{ color: "#212529" }}
              >
                Support
              </h6>
              <p>
                <a
                  href="#!"
                  className="text-reset"
                  style={{ fontSize: "14px" }}
                >
                  FAQs
                </a>
              </p>
              <p>
                <a
                  href="#!"
                  className="text-reset"
                  style={{ fontSize: "14px" }}
                >
                  Contact Us
                </a>
              </p>
              <p>
                <a
                  href="#!"
                  className="text-reset"
                  style={{ fontSize: "14px" }}
                >
                  Resources
                </a>
              </p>
              <p>
                <a
                  href="#!"
                  className="text-reset"
                  style={{ fontSize: "14px" }}
                >
                  Privacy Policy
                </a>
              </p>
              <p>
                <a
                  href="#!"
                  className="text-reset"
                  style={{ fontSize: "14px" }}
                >
                  Terms of Service
                </a>
              </p>
            </MDBCol>

            <MDBCol
              md="4"
              lg="3"
              xl="3"
              className="mx-auto mb-md-0 mb-4"
              style={{ textAlign: "center" }}
            >
              <h6
                className="text-uppercase fw-bold mb-4"
                style={{ color: "#212529" }}
              >
                Contact
              </h6>
              <p style={{ fontSize: "14px" }}>
                <MDBIcon color="secondary" icon="home" className="me-2" />
                &nbsp; 1st Floor, Banglow No. 17, Prashant Society, Paud Road,
                Kothrud, Pune 411038
              </p>
              <p style={{ fontSize: "14px" }}>
                <MDBIcon color="secondary" icon="envelope" className="me-3" />
                &nbsp; info@texasschoolmh.com
              </p>
              <p style={{ fontSize: "14px" }}>
                <MDBIcon color="secondary" icon="phone" className="me-3" />
                &nbsp; + 01 234 567 88
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div
        className="text-center p-4"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
      >
        © 2025 Copyright&nbsp;
        <a className="text-reset fw-bold" href="https://www.texasschoolmh.com/">
          texasschoolmh.com
        </a>
      </div>
    </MDBFooter>
  );
}
